import { localPrice } from "@/api/dtos";
import { FullItemOrder } from "@/api/order";
import i18n from "@/i18n";

export const ArticleOrderRecap = ({ item }: { item: FullItemOrder }) => {
  const sellable = item.relatedArticle.sellableContent;

  return (
    <div className="border border-solid border-gray-300 rounded-xl grid grid-cols-4 p-4 gap-4">
      <div className="col-span-1 flex flex-col justify-center">
        <img
          className="object-contain  w-full"
          src={sellable.previews.at(0)?.medium ?? ""}
          alt=""
        />
      </div>
      <div className="col-span-3 flex-col flex justify-between gap-2">
        <div className="flex flex-col">
          <div className="leading-8">
            <span className="font-bold">{sellable.title}</span>
            {sellable.dateInfo && <span>, {sellable.dateInfo}</span>}
          </div>
          <span className="text-sm">{sellable.technique["fr"]}</span>
          <span className="text-sm">
            {sellable.signature.location["fr"]}
            {sellable.signature.transcript && (
              <> "{sellable.signature.transcript}"</>
            )}
          </span>
        </div>
        <div className="flex flex-row justify-between">
          <span className="text-lg">
            {localPrice(i18n.language, item.relatedArticle.priceAmount)} €
          </span>
          {item.quantity > 1 && <span>{item.quantity} examplaires</span>}
        </div>
      </div>
    </div>
  );
};
